module.exports = __webpack_public_path__ + "img/vcontroller-logo@2x.dbed41a1.png";